export default function FloatingCTA({ settings }) {
  const phone = settings?.phone || '22 18 73 30'
  const phoneRaw = settings?.phone_raw || '22187330'
  const email = settings?.email || 'steen@ekbiler.dk'
  const bookingUrl = settings?.booking_url || 'https://service.dinbilpartner.dk/book-tid'
  const facebookUrl = settings?.facebook_url || 'https://www.facebook.com/ekbiler.dk/'

  return (
    <aside
      aria-label="Hurtig kontakt og tidsbestilling"
      className="fixed bottom-5 right-4 sm:bottom-6 sm:right-5 z-40 flex flex-col items-end gap-2.5 sm:gap-3"
    >
      {/* 1. Book tid (High Priority Action) */}
      <div className="relative group flex items-center">
        <span
          role="tooltip"
          className="hidden sm:block absolute right-full mr-3 px-2.5 py-1 text-xs font-bold text-white bg-gray-900/95 backdrop-blur-sm rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-150 pointer-events-none whitespace-nowrap"
        >
          Book tid online
        </span>
        <a
          href={bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Book tid online hos EK Biler"
          className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#e20019] hover:bg-[#b80014] text-white flex items-center justify-center shadow-lg hover:shadow-red-600/40 hover:scale-110 active:scale-95 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600"
        >
          <i className="fa-solid fa-calendar-check text-base sm:text-lg" aria-hidden="true" />
        </a>
      </div>

      {/* 2. Telefon opkald */}
      <div className="relative group flex items-center">
        <span
          role="tooltip"
          className="hidden sm:block absolute right-full mr-3 px-2.5 py-1 text-xs font-bold text-white bg-gray-900/95 backdrop-blur-sm rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-150 pointer-events-none whitespace-nowrap"
        >
          Ring til værkstedet: {phone}
        </span>
        <a
          href={`tel:${phoneRaw}`}
          aria-label={`Ring til ${phone}`}
          className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#14171a] hover:bg-[#232930] text-white flex items-center justify-center shadow-lg hover:shadow-black/30 hover:scale-110 active:scale-95 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-700 border border-[#2e353e]"
        >
          <i className="fa-solid fa-phone text-sm sm:text-base text-[#e20019]" aria-hidden="true" />
        </a>
      </div>

      {/* 3. E-mail */}
      <div className="relative group flex items-center">
        <span
          role="tooltip"
          className="hidden sm:block absolute right-full mr-3 px-2.5 py-1 text-xs font-bold text-white bg-gray-900/95 backdrop-blur-sm rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-150 pointer-events-none whitespace-nowrap"
        >
          Send e-mail: {email}
        </span>
        <a
          href={`mailto:${email}`}
          aria-label={`Send en e-mail til ${email}`}
          className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-white hover:bg-gray-50 text-gray-800 hover:text-[#e20019] flex items-center justify-center shadow-md hover:shadow-lg hover:scale-110 active:scale-95 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 border border-gray-200"
        >
          <i className="fa-solid fa-envelope text-sm sm:text-base" aria-hidden="true" />
        </a>
      </div>

      {/* 4. Facebook */}
      <div className="relative group flex items-center">
        <span
          role="tooltip"
          className="hidden sm:block absolute right-full mr-3 px-2.5 py-1 text-xs font-bold text-white bg-gray-900/95 backdrop-blur-sm rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-150 pointer-events-none whitespace-nowrap"
        >
          Følg os på Facebook
        </span>
        <a
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Følg EK Biler på Facebook"
          className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#1877f2] hover:bg-[#166fe5] text-white flex items-center justify-center shadow-md hover:shadow-blue-500/30 hover:scale-110 active:scale-95 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
        >
          <i className="fa-brands fa-facebook-f text-sm sm:text-base" aria-hidden="true" />
        </a>
      </div>
    </aside>
  )
}
